module.exports = __webpack_public_path__ + "static/media/unpaid-material.cb9810e4.png";